import { createTheme } from "../utils/create-theme";
export var VILLARS_THEME = createTheme('villars', {
  activeMode: 'light',
  light: {
    color: {
      primary: '#005D25',
      secondary: '#000000',
      lineMid: '#00000022',
      appChrome: '#F5F5F5',
      primaryDarker: '#053418',
      primaryLight: '#3A8559',
      primaryLighter: '#9DC2AC',
      primaryBright: '#09672F',
      primaryVeryLight: '#E6F0EA',
      link: '#005D25',
      linkHover: '#000000',
      navigationActive: '#005D25',
      accentDark: '#053418',
      accentLight: '#3A8559'
    }
  },
  dark: {
    color: {}
  }
});
export default VILLARS_THEME;